import getUrlParams from './getUrlParams.js';

export default function LotteriesResultsSearch () {

    const LIMIT = 15,
    INPUT_TIMEOUT_DELAY = 500,
    SCROLL_TIMEOUT_DELAY = 50;

    let searchInput,
    searchContainer  = document.getElementById('lotteriesResultsSearch'),
    countrySelect,
    stateSelect,
    pagination,
    minJackpotInput,
    maxJackpotInput,
    resultsNode,
    preloader,
    sortSelect,
    nonce,
    sortingFunctions,
    results,
    urlParams,
    resultsPages,
    countriesStates = [],
    inputTimeout = null,
    scrollTimeout = null;

    if (!searchContainer) return;

    sortingFunctions = {
        alph: function( a, b ) {
            let tA = a.name.toUpperCase();
            let tB = b.name.toUpperCase();
            return (tA < tB) ? -1 : (tA > tB) ? 1 : 0;
        },

        lJck: function( a, b ) {
            return b.jackpot - a.jackpot;
        },

        sJck: function( a, b ) {
            return a.jackpot - b.jackpot;
        },

        nDrw: function( a, b ) {
            return a.nextdraw_date - b.nextdraw_date;
        }
    }

    function init() {
        nonce = document.getElementById('lotteriesResultsSearch-nonce').value;
        searchInput = document.querySelector('.lotteriesResultsSearch-input');
        countrySelect = document.querySelector('.lotteriesResultsSearch-selectCountry');
        stateSelect = document.querySelector('.lotteriesResultsSearch-selectState');

        minJackpotInput = document.querySelector('.lotteriesResultsSearch-minJackpot');
        maxJackpotInput = document.querySelector('.lotteriesResultsSearch-maxJackpot');

        preloader = document.querySelector('.lotteriesResultsSearch-preload');
        resultsNode = document.querySelector('.lotteriesResultsSearch-results');

        sortSelect = document.querySelector('.lotteriesResultsSearch-sort');
        urlParams = getUrlParams(window.location.search);
        resultsPages = document.querySelectorAll('.lotteriesResultsSearch-resultsPage');

        pagination = document.getElementById('lotteriesResultsSearch-pagination');
        pagination.parentNode.removeChild(pagination);

       if(!urlParams.page_n) urlParams.page_n=1;

       [].forEach.call(resultsPages, (el) => {

            if( el.innerHTML!='<div class="preloader"></div>'){
                el.loaded= true;
            }

       });
        
        fetch( '/wp-json/lotterycritic/v2/get_lotteries_countries_states_list/',
            {   method: 'get',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce,
                }
            }
        ).then( function(response) {
            return response.json().then( 
                function( json ) {
                   countriesStates = json;
                   initFilters();
                   preloader.style.display = 'none';
                   initPaginator();
                }
            );
        });
        
    }

    function initPaginator() {
        let currentPage = urlParams.page_n,

        currentPageNodeHeight = document.getElementById('resultsPage-'+urlParams.page_n).offsetHeight;

        setPlaceholdersHeight( currentPageNodeHeight );

        checkVisible();

        window.addEventListener('scroll', 
            () => {
                if (scrollTimeout !== scroll) {
                    clearTimeout(scrollTimeout);
                }

                scrollTimeout = setTimeout(checkVisible, SCROLL_TIMEOUT_DELAY);
          }
        );
    }

    function setPlaceholdersHeight( height ) {

        [].forEach.call(resultsPages, (el) => {
            el.style.height = height + 'px';
        });
    }

    function checkVisible() {
      let rect,
      viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight),
      scrollTop = window.scrollY,
      visibleHeight,
      maxVisibleHeight = 0,
      mostVisibleID='',
      pageN;


      [].forEach.call(resultsPages, (el) => {

        rect = el.getBoundingClientRect();

 
        visibleHeight = rect.height;

        if( rect.top < 0 ) {
            visibleHeight+=rect.top; 
        }

        if( rect.bottom > viewHeight ) {
            visibleHeight-=rect.bottom - viewHeight;
        }

        if( visibleHeight > maxVisibleHeight ) {
            maxVisibleHeight = viewHeight;
            mostVisibleID = el.id;
        }

        if( !el.loaded ) {
          
            if( !( rect.bottom < 0 || rect.top - viewHeight >= 0 ) ) {
                el.loaded = "in process";
                search(el);
            }
        }

      });

      pageN = mostVisibleID.split('resultsPage-')[1];


      if( urlParams.page_n != pageN ) {
         urlParams.page_n = pageN;
         if(pageN){
            setURLParams();
            
         }
      }
    }

    function setURLParams () {


       window.history.replaceState( '', '','?'+Object.keys( urlParams ).map( key => `${key}=${encodeURIComponent( urlParams[key])}` ).join( '&' ) );
      
    }

    function inputSearchDelay() {

            if (inputTimeout !== null) {
                clearTimeout(inputTimeout);
            }

            inputTimeout = setTimeout(()=> {
                setURLParams ();
                search();
            }, INPUT_TIMEOUT_DELAY);
    }

    function initFilters() {
       
        Object.keys(countriesStates).forEach( ( country ) => {
            countrySelect.innerHTML += `<option value="${country}" ${urlParams.country==country?' selected':''}>${country}</option>`;
        } );

        if (urlParams.country) {
            stateSelect.disabled = false;
            stateSelect.innerHTML = `<option value="">Select State</option>`;
            countriesStates[urlParams.country].forEach( ( state ) => {
                stateSelect.innerHTML += `<option value="${state}" ${urlParams.state==state?' selected':''} >${state}</option>`;
            } );
        }

        searchInput.addEventListener('input', ()=> {
            let val = searchInput.value.trim();
            urlParams.searchText = val;
            inputSearchDelay();

        });

        minJackpotInput.addEventListener('input', ()=> {

            if(Number(minJackpotInput.value) > Number(maxJackpotInput.value)) {
                maxJackpotInput.value = minJackpotInput.value;
                urlParams.maxjackpot =  maxJackpotInput.value;
            }

            urlParams.minjackpot = minJackpotInput.value;
            inputSearchDelay();
        });

        maxJackpotInput.addEventListener('input', ()=> {

            if(Number(maxJackpotInput.value) < Number(minJackpotInput.value)) {
                minJackpotInput.value = maxJackpotInput.value;
                urlParams.minjackpot =  maxJackpotInput.value;
            }

            urlParams.maxjackpot = maxJackpotInput.value;
            inputSearchDelay();
        });

        countrySelect.addEventListener('change',()=>{
           
            if( countrySelect.value == "") {
                stateSelect.disabled = true;
                stateSelect.innerHTML = `<option value="">-</option>`;
                delete urlParams.country;
            }else {
                stateSelect.disabled = false;
                stateSelect.innerHTML = `<option value="">Select State</option>`;
                urlParams.country = countrySelect.value;

                countriesStates[countrySelect.value].forEach( ( state ) => {
                    stateSelect.innerHTML += `<option value="${state}">${state}</option>`;
                } );
            }

            delete urlParams.state;

            urlParams.page_n = 1;

            setURLParams();
            search();
        });

        stateSelect.addEventListener('change', () => {

            if(stateSelect.value == "") {

                delete urlParams.state;

            }else {
                urlParams.state = stateSelect.value;
            }
            setURLParams();
            search();
        });

        sortSelect.addEventListener('change', () => {
            urlParams.sort = sortSelect.value;
            setURLParams();
            search();
        });
       
    }

    function newSearch (data) {

        let html = '',
            resultPageNode,
            totalPages = data.total;

        if(totalPages == 0) {
            resultsNode.innerHTML = "Nothing found";
            return;
        }
       
        for (let i = 1; i <= totalPages; i++) {
            html += `<div class="lotteriesResultsSearch-resultsPage" id="resultsPage-${i}"></div>`;
        }

        resultsNode.innerHTML = html;

        resultsPages = resultsNode.querySelectorAll('.lotteriesResultsSearch-resultsPage');
        resultsPages[0].loaded = true;
        resultsPages[0].innerHTML = data.html;
        resultsPages[0].style.height = '';
        setPlaceholdersHeight( resultsPages[0].offsetHeight );

    }

    function search( targetNode ) {

        let pageN = targetNode?targetNode.id.split("resultsPage-")[1]:1,
            data  = {searchText: searchInput.value.trim(), 
            country: countrySelect.value, 
            state: stateSelect.value, 
            minJ:minJackpotInput.value, 
            maxJ:maxJackpotInput.value,
            sort:sortSelect.value,
            page_n:pageN};

        fetch( '/wp-json/lotterycritic/v2/lotteries_results_search/', {
                method: 'post',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': nonce,
                    },
                body: JSON.stringify(data)
        } ).then( function( response ) {
                return response.json().then(

                    function( json ) {

                        if( targetNode ) {

                          targetNode.loaded = true;

                          targetNode.innerHTML = json.html;
                          
                          targetNode.style.height = '';

                        }else {
                            newSearch(json);
                        }
                    }

                );
        });
    }

    function convertDate( timestamp ) {

        let a = new Date(timestamp * 1000),
            months = ['Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'],
            y = a.getFullYear(),
            m = months[a.getMonth()],
            d = a.getDate();

      return d + ' ' + m + ' ' + y;
    }
 


  
    init();
}


// WEBPACK FOOTER //
// ./js/src/lotteriesResultsSearch.js